// RoleRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const RoleRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const temPermissao = allowedRoles.some((r) => (user?.roles || []).includes(r));
  if (!temPermissao) return <Navigate to="/" replace />;

  return children;
};

export default RoleRoute;